import Styles from './EventIconContainer.module.scss'
import { PropsWithChildren } from 'react'

export const EventIconContainer = ({ children }: PropsWithChildren) => (
  <div className={Styles.wrapper}>
    <div className={Styles.circle}>{children}</div>
  </div>
)
